/**
 * Desplazamiento a un apartado del documento desde su índice.
 *
 * Vive aquí y no en cada componente porque lo usan las dos páginas de texto
 * largo del sitio público —«Términos y condiciones» y «Marco legal»—, y las dos
 * tienen que respetar la preferencia de movimiento reducido de la misma forma:
 * para quien la lleva activada, un desplazamiento animado de varias pantallas
 * puede provocar mareo.
 *
 * El hueco por debajo de la cabecera fija lo pone el CSS con `scroll-margin-top`
 * en los títulos (ver el mixin `prose`); sin él el apartado al que se salta
 * queda tapado por la cabecera.
 */
export function scrollToSection(sectionId: string, event: Event): void {
  event.preventDefault();

  const element = document.getElementById(sectionId);
  if (!element) return;

  const prefersReduced = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;

  element.scrollIntoView({
    behavior: prefersReduced ? 'auto' : 'smooth',
    block: 'start',
  });
}
